import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@yonderland/andes-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { DELAY } from '../../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { authActions } from '../../../redux/authentication/actions/AuthActions.creators';
import { makeGetLoginError, makeGetLoginLoading, makeGetResetPasswordState, } from '../../../redux/authentication/selectors/AuthSelectors';
import { ForgotPassword } from '../../account/authentication/ForgotPassword';
import { Login } from '../../account/authentication/Login';
import { MobileNavigationItemContent } from './MobileNavigationItemContent';
export const MobileNavigationLoginLevel = ({ actionUri, registrationLink, isTabActive, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const [forgotPasswordActive, setForgotPasswordActive] = useState(false);
    const [email, setEmail] = useState('');
    const loading = useSelector(makeGetLoginLoading());
    const resetPasswordState = useSelector(makeGetResetPasswordState());
    const loginError = useSelector(makeGetLoginError());
    const dispatch = useDispatch();
    const handleLoginSubmit = (values) => dispatch(authActions.login({
        username: values.email,
        password: values.password,
        keepSignedIn: values.keepSignedIn,
        reloadOnSuccess: true,
    }));
    const resetForgotPasswordState = () => {
        (resetPasswordState.success || resetPasswordState.error) &&
            dispatch(authActions.createResetCredentialsSuccessAction(null));
    };
    const handleResetPasswordSubmit = (values) => dispatch(authActions.createResetCredentialsAction(values.email));
    const handleForgotPasswordEmailChange = (email) => {
        setEmail(email);
        resetForgotPasswordState();
    };
    const toggleView = () => {
        setForgotPasswordActive(!forgotPasswordActive);
        resetForgotPasswordState();
    };
    useEffect(() => {
        forgotPasswordActive && setTimeout(() => setForgotPasswordActive(false), DELAY.DELAY_250); // reset state after menu animations completes
    }, [isTabActive]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { paddingBlockEnd: "2", children: _jsx(MobileNavigationItemContent, { emphasized: true, children: forgotPasswordActive ? t('account.login.title.password.forgotten') : t('account.login.title.login') }) }), forgotPasswordActive ? (_jsx(ForgotPassword, { onSubmit: handleResetPasswordSubmit, errorFeedback: resetPasswordState.error, successFeedback: resetPasswordState.success, initialEmail: email, backToLoginClicked: toggleView, onEmailChange: handleForgotPasswordEmailChange })) : (_jsx(Login, { login: {
                    action: actionUri,
                    onSubmit: handleLoginSubmit,
                    errorFeedback: loginError,
                    forgotPasswordClicked: toggleView,
                    initialEmail: email,
                    loading,
                }, registrationLink: registrationLink, onAuthResetForm: () => dispatch(authActions.resetError()) }))] }));
};
